var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecontact = function SvgRecontact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2935"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2934"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#39F",
    d: "M10.35 47.998a6.5 6.5 0 0 1-6.5-6.5V12.123h62.433a6.5 6.5 0 0 1 6.5 6.5 6.5 6.5 0 0 1-6.5 6.5H16.85v16.375a6.5 6.5 0 0 1-6.5 6.5",
    "data-name": "Path 6129"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M69.65 34.358a6.5 6.5 0 0 1 6.5 6.5v29.141H13.717a6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.5-6.5H63.15V40.858a6.5 6.5 0 0 1 6.5-6.5",
    "data-name": "Path 6130"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#39F",
    d: "M61.029 32.245a4.98 4.98 0 0 1-3.535-1.465 5 5 0 0 1 0-7.07l5.086-5.088-5.086-5.086a5 5 0 0 1 0-7.07 5 5 0 0 1 7.071 0l12.158 12.156L64.565 30.78a4.98 4.98 0 0 1-3.536 1.465",
    "data-name": "Path 6128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M18.971 49.878a4.98 4.98 0 0 1 3.536 1.464 5 5 0 0 1 0 7.071l-5.087 5.088 5.087 5.085a5 5 0 0 1 0 7.071 5 5 0 0 1-7.071 0L3.278 63.501l12.158-12.158a4.99 4.99 0 0 1 3.535-1.465",
    "data-name": "Path 6131"
  })))));
};
export default SvgRecontact;